/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Equipment_BarbellInputs */

const en_us2_onboarding_equipment_barbell = /** @type {(inputs: Onboarding_Equipment_BarbellInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Barbell`)
};

const pt_br2_onboarding_equipment_barbell = /** @type {(inputs: Onboarding_Equipment_BarbellInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Barra`)
};

const es_419_onboarding_equipment_barbell = /** @type {(inputs: Onboarding_Equipment_BarbellInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Barra`)
};

const pt_pt2_onboarding_equipment_barbell = /** @type {(inputs: Onboarding_Equipment_BarbellInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Barra`)
};

const fr_fr2_onboarding_equipment_barbell = /** @type {(inputs: Onboarding_Equipment_BarbellInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Barre`)
};

const de_de2_onboarding_equipment_barbell = /** @type {(inputs: Onboarding_Equipment_BarbellInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Langhantel`)
};

const it_it2_onboarding_equipment_barbell = /** @type {(inputs: Onboarding_Equipment_BarbellInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bilanciere`)
};

/**
* | output |
* | --- |
* | "Barbell" |
*
* @param {Onboarding_Equipment_BarbellInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_equipment_barbell = /** @type {((inputs?: Onboarding_Equipment_BarbellInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Equipment_BarbellInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_equipment_barbell(inputs)
	if (locale === "es-419") return es_419_onboarding_equipment_barbell(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_equipment_barbell(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_equipment_barbell(inputs)
	if (locale === "de-DE") return de_de2_onboarding_equipment_barbell(inputs)
	if (locale === "it-IT") return it_it2_onboarding_equipment_barbell(inputs)
	return en_us2_onboarding_equipment_barbell(inputs)
});
export { onboarding_equipment_barbell as "onboarding.equipment.barbell" }